import React from "react";
import FirmarCertificados from "./Certificados/FirmarCertificados";
import CronogramaVacaciones from "./Vacaciones/CronogramaVacaciones";
//URL
import configData from "../../config.json";
import NotificacionEmbarazoTh from "./NotificacionEmbarazo/NotificacionEmbarazoTh";
import AprobacionSolicitudesTh from "./AprobacionesSolicitudes/AprobacionSolicitudesTh";
import FirmaAPNomina from "./FirmaAPNomina/FirmaAPNomina";
import FirmaRRevision from "./RevisionSolicitudes/RevisionSolicitudes";
import HistorialAprobaciones from "./HistorialAprobaciones/HistorialAprobaciones";
import ContainerParametros from "./Horas Extras/Parametros Horas Extras/ContainerParametros";
import ProyeccionUnidades from "./Horas Extras/Proyeccion Horas Extras/ProyeccionUnidades";
import PlanificacionUnidades from "./Horas Extras/Planificacion Horas Extras/PlanificacionUnidades";

import RevisionSolicitudes from "./RevisionSolicitudes/RevisionSolicitudes";
import RegistroSolicitudes from "./RegistroSolicitudes/RegistroSolicitudes";
import ConsultaHojaPorUsuario from "./HojaMarcaciones/ConsultaHojaPorUsuario";
import ConsultaReportePorUnidad from "./HojaMarcaciones/ConsultaReportePorUnidad";

import AsignarCur from "./Horas Extras/Asignar numero CUR/AsignarCur";
import PruebaAsignarCur from "./Horas Extras/Asignar numero CUR/PruebaAsignarCur";
import { RevisarSolicitudesHE } from "./Horas Extras/Revisar Solicitudes Horas Extras/RevisarSolicitudesHE";
import { DocumentoPagoEspolHE } from "./Horas Extras/Revision Documento Pago Horas Extras/DocumentosPagoESPOLHE";
import { HistorialSolicitudesHE } from "./Horas Extras/Historial Solicitudes/HistorialSolicitudes";
import HistorialEstadoNotificado from "./HistorialAprobaciones/HistorialEstadoNotificado";
import AprobacionVacaciones from "./AprobacionesVacaciones/AprobacionVacaciones";
import RevisionSolicitudV from "./RevisionVacaciones/RevisionSolicitudV";
import FirmaAPVacaviones from "./FirmaAPVacaciones/FirmaAPVacaciones";
import RegistroSolicitudesV from "./RegistroVacaciones/RegistroSolicitudesV";
import HistorialAprobacionesV from "./HistorialVacaciones/HistorialAprobacionesV";
import SolicitudManualHE from "./Horas Extras/Ingreso Manual Solicitudes HE/SolicitudManualHE";
import { EjecucionPresupuestaria } from "./Horas Extras/Ejecucion Presupuestaria HE/EjecucionPresupuestariaHE";



const ADMINISTRADOR_ROUTES: Array<{ path: string, component: any, layout: string }> = [

    {
        path: "/cronogramaVacaciones",
        component: CronogramaVacaciones,
        layout: "/admin",
    },
    {
        path: "/firmarCertificados",
        component: FirmarCertificados,
        layout: "/admin",
    },
    {
        path: "/aprobacionSolicitudesTh",
        component: AprobacionSolicitudesTh,
        layout: "/admin",
    },
    {
        path: "/aprobacionVacacionesTh",
        component: AprobacionVacaciones,
        layout: "/admin",
    },
    {
        path: "/validacionNotificacionEmbarazo",
        component: NotificacionEmbarazoTh,
        layout: "/admin",
    },
    {
        path:"/hojaMarcacionesServidor",
        component: ConsultaHojaPorUsuario,
        layout:"/admin"
    },
    {
        path:"/hojaMarcacionesUnidad",
        component: ConsultaReportePorUnidad,
        layout:"/admin"
    },
    {
        path: "/firmaAPNomina",
        component: FirmaAPNomina,
        layout: "/admin",
    },
    {
        path: "/firmaAPVacaciones",
        component: FirmaAPVacaviones,
        layout: "/admin",
    },
    {
        path: "/revisionSolicitudes",
        component: RevisionSolicitudes,
        layout: "/admin",
    },
    {
        path: "/revisionVacacionesTh",
        component: RevisionSolicitudV,
        layout: "/admin",
    },
    {
        path: "/registroSolicitudes",
        component: RegistroSolicitudes,
        layout: "/admin",
    },
    {
        path: "/registroVacacionesTh",
        component: RegistroSolicitudesV,
        layout: "/admin",
    },
    {
        path: "/historialSolicitudesTH",
        component: HistorialAprobaciones,
        layout: "/admin",
    },
    {
        path: "/horasExtras/parametros",
        component: ContainerParametros,
        layout: "/admin"
    },
    {
        path: "/horasExtras/proyeccion",
        component: ProyeccionUnidades,
        layout: "/admin"


    },
    {
        path: "/horasExtras/planificacion",
        component: PlanificacionUnidades,
        layout: "/admin"
    },
    {
        path: "/horasExtras/Asignar",
        component: PruebaAsignarCur,
        layout: "/admin"
    },
    {
        path: "/horasExtras/Revisar",
        component: RevisarSolicitudesHE,
        layout: "/admin"
    },
    {
        path: "/horasExtras/firmadocumentopago",
        component: DocumentoPagoEspolHE,
        layout: "/admin"
    },
    {
        path: "/horasExtras/historialSolicitudes",
        component: HistorialSolicitudesHE,
        layout: "/admin"
    },
    {
        path: "/horasExtras/solicitudpago",
        component: SolicitudManualHE,
        layout: "/admin"
    }
    ,
    {
        path: "/historialSolicitudesNotificadoTH",
        component: HistorialEstadoNotificado,
        layout: "/admin",
    },
    {
        path: "/historialVacacionesTh",
        component: HistorialAprobacionesV,
        layout: "/admin",
    },
    {
        path: "/horasExtras/historicounidades",
        component: EjecucionPresupuestaria,
        layout: "/admin"
    },
];
export default ADMINISTRADOR_ROUTES;
